import handleInViewport from "react-in-viewport"
import { StatisticsBlock } from "../Components/StatisticsBlock"

const StatisticsBlockViewport = handleInViewport(StatisticsBlock)

export function StatisticsBlockContainer(props) {
    return <StatisticsBlockViewport {...props}></StatisticsBlockViewport>
}